import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import StandardModal from 'components/consumer/StandardModal';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import IconDimensions from 'components/icons/IconDimensions';
import { colorBrandDark } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const PDPDimensionsModal = t0 => {
  const $ = _c(4);
  const {
    isOpen: t1,
    onClose
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FixedWidthContainer><div className="items-center flex justify-center mt-12 mx-auto mb-8"><span className="items-center bg-brand-lightest flex h-11 justify-center mr-4 w-11"><IconDimensions color={colorBrandDark} /></span><span className="text-3xl font-bold text-gray">Dimensions</span></div><PDPDimensionsContent /></FixedWidthContainer>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isOpen || $[2] !== onClose) {
    t3 = <StandardModal className="PDPDimensionsUI" isOpen={isOpen} size="xl" theme="light" onClose={onClose}>{t2}</StandardModal>;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
PDPDimensionsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
export default withBrowserOnly(PDPDimensionsModal);